import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

export default class StyleButton extends PureComponent {
  static propTypes = {
    isActive: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onToggle: PropTypes.func.isRequired,
    style: PropTypes.string.isRequired
  };

  handleToggle = e => {
    e.preventDefault();
    this.props.onToggle(this.props.style);
  };

  render() {
    return (
      <span
        className={classNames("rich-editor__style-button", { "--active": this.props.isActive })}
        onMouseDown={this.handleToggle}
        role="button"
        tabIndex="0">
        {this.props.label}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/RichEditor/StyleButton.js